<template>
<div class="chapter">
<div class="inner_page">
<div class="element element-non-bodymatter element-container-single element-type-dedication element-without-heading full-character-formatting" id="dedication">
<div class="text" id="dedication-text">
<div class="alignment-block alignment-block-align-center">
<div class="text-block">
<p class="alignment-block-content alignment-block-content-center dedication-content">For my readers.</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">If you hadn’t asked for a Meredith and Donovan book, I never would’ve written it. And that would’ve been sad. I loved getting to know Meredith more. Plus, Donovan! #swoon</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">Thank you for reading! I appreciate each and every one of you!</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">❤</p>
<p class="alignment-block-content alignment-block-content-center dedication-content">Aileen</p>
</div>
</div>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// dedication.vue?1d720b65